import { createContext } from "react";
import type { ValidatedWorkspaceGlobals } from "../index";

export type CurrentWorkspaceGlobalsContextType = {
  globals: ValidatedWorkspaceGlobals;
};

export const CurrentWorkspaceGlobalsContext = createContext<
  CurrentWorkspaceGlobalsContextType | undefined
>(undefined);
